// extracted by mini-css-extract-plugin
module.exports = {"checkboxContainer":"ReadOnlyCustomField_checkboxContainer__1CMH-"};